import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import classNames from 'classnames';

const { Icon } = designSystem;

function IconStatus({ iconGlyph, iconType, children, align = 'left' }) {
  const classes = classNames('ws-icon-status', `ws-icon-status--${align}`);

  return (
    <div className={classes}>
      <Icon glyph={iconGlyph} type={iconType} />
      {children}
    </div>
  );
}

IconStatus.propTypes = {
  iconGlyph: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(['left', 'right', 'center']),
};

export default IconStatus;
